/**
 * Разделение числа на разряды
 * */
export default function (value: number | null | undefined) {
	if (!value) {
		return '0';
	}

	const hasDecimal = value.toString().includes('.');
	const parts = hasDecimal ? value.toFixed(2).split('.') : [value.toString()];
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	return hasDecimal ? parts.join('.') : parts[0];
}
